'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileAccordion = function MobileAccordion(el) {
  (0, _classCallCheck3.default)(this, MobileAccordion);

  // Convert footer links into an accordion
  function mobile_accordion() {
    (0, _jquery2.default)('.ft-Footer_Title_Accordion').unbind().click(function (e) {
      var d_activeTab = (0, _jquery2.default)(this).attr('rel');
      console.log((0, _jquery2.default)(this).hasClass('d_active'));

      if ((0, _jquery2.default)(this).hasClass('d_active')) {
        (0, _jquery2.default)('#' + d_activeTab).slideUp();
        (0, _jquery2.default)(this).removeClass('d_active');
        (0, _jquery2.default)(this).children('i').removeClass('i-chevron-up').addClass('i-chevron-down');
      } else {
        (0, _jquery2.default)('#' + d_activeTab).slideDown();
        (0, _jquery2.default)(this).addClass('d_active');
        (0, _jquery2.default)(this).children('i').removeClass('i-chevron-down').addClass('i-chevron-up');
      }

      e.preventDefault();
    });
  }

  (0, _jquery2.default)(document).ready(function () {
    if ((0, _jquery2.default)(window).width() < 900) {
      mobile_accordion();
    }
  });

  (0, _jquery2.default)(window).resize(function () {
    if ((0, _jquery2.default)(window).width() < 900) {
      mobile_accordion();
    }
  });
};

exports.default = MobileAccordion;